import moment from "moment";

function checkDateToFormat(date) {
  if (!date || date == "null" || date == "Invalid date") {
    return "";
  } else if (moment(date, "DD/MM/YY", true).isValid()) {
    return date;
  } else if (moment(date, "DD/MM/YY HH:mm", true).isValid()) {
    return moment(date, "DD/MM/YY HH:mm").format("DD/MM/YY");
  } else if (moment(date, "DD/MM/YYYY", true).isValid()) {
    return moment(date, "DD/MM/YYYY").format("DD/MM/YY");
  } else if (moment(date, "YYYY/MM/DD", true).isValid()) {
    return moment(date, "YYYY/MM/DD").format("DD/MM/YY");
  } else if (moment(date, "YYYY-MM-DD", true).isValid()) {
    return moment(date, "YYYY-MM-DD").format("DD/MM/YY");
  } else if (moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
    return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YY");
  } else {
    return moment(date).format("DD/MM/YY") == "Invalid date"
      ? " "
      : moment(date).format("DD/MM/YY");
  }
}

function checkDateTimeToFormat(date) {
  var dateReturn = "";

  if (!date || date == "null" || date == "Invalid date") {
    dateReturn = "";
  } else if (moment(date, "DD/MM/YY", true).isValid()) {
    dateReturn = moment(date, "DD/MM/YYYY").format("DD/MM/YY HH:mm");
  } else if (moment(date, "DD/MM/YY HH:mm", true).isValid()) {
    dateReturn = date;
  } else if (moment(date, "DD/MM/YYYY HH:mm:ss", true).isValid()) {
    dateReturn = moment(date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YY");
  } else if (moment(date, "YYYY/MM/DD", true).isValid()) {
    dateReturn = moment(date, "YYYY/MM/DD").format("DD/MM/YY HH:mm");
  } else if (moment(date, "YYYY-MM-DD", true).isValid()) {
    dateReturn = moment(date, "YYYY-MM-DD").format("DD/MM/YY HH:mm");
  } else if (moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
    dateReturn = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YY HH:mm");
  } else if (moment(date, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
    dateReturn = moment(date, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YY HH:mm");
  } else if (moment(date, "DD-MM-YYYY HH:mm", true).isValid()) {
    dateReturn = moment(date, "DD-MM-YYYY HH:mm").format("DD/MM/YY HH:mm");
  } else {
    dateReturn = moment(date).format("DD/MM/YY HH:mm");
  }
  return dateReturn == "Invalid date" ? " " : dateReturn;
}

function checkDateToFormatDynamic(date, newDate) {
  // console.log(date);
  var dateReturn = null;
  if (!date || date == "null" || date == "Invalid date") {
    dateReturn = "";
  } else if (moment(date, "DD/MM/YY", true).isValid()) {
    dateReturn = moment(date, "DD/MM/YY").format(newDate);
  } else if (moment(date, "DD/MM/YY HH:mm", true).isValid()) {
    dateReturn = moment(date, "DD/MM/YY HH:mm").format(newDate);
  } else if (moment(date, "DD/MM/YYYY", true).isValid()) {
    dateReturn = moment(date, "DD/MM/YYYY").format(newDate);
  } else if (moment(date, "YYYY/MM/DD", true).isValid()) {
    dateReturn = moment(date, "YYYY/MM/DD").format(newDate);
  } else if (moment(date, "YYYY-MM-DD", true).isValid()) {
    dateReturn = moment(date, "YYYY-MM-DD").format(newDate);
  } else if (moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
    dateReturn = moment(date, "YYYY-MM-DD HH:mm:ss").format(newDate);
  } else {
    dateReturn = moment(date).format(newDate);
  }

  return dateReturn == "Invalid date" ? " " : dateReturn;
}

export { checkDateToFormat, checkDateTimeToFormat, checkDateToFormatDynamic };
